import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const icon = css`
  inline-size: auto;
  block-size: ${spacing(10.625)}; // 85px
`
export const qr = css`
  image-rendering: pixelated;
`
